import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import algoliasearch from 'algoliasearch/lite';
import { FormType } from 'common/components/QuickQuoteForm/types';
import { InstantSearch, Index } from 'react-instantsearch-dom';
import { openModal } from '../../../helpers/modalHelper';
import {
  StateResults, CustomSearchBox, CustomHits, cities, workspaceTypes,
} from './fragments';
import { viewStore } from '../../../stores/ViewStore';
import {
  logo, avatar, search, burger, close, link,
// @ts-ignore
} from '../../../assets';
import { ReactComponent as Chevron } from '../../../assets/icons/chevron.svg';
import PhoneIcon from '../../../assets/icons/phone.png';
import { screenStore } from '../../../stores/ScreenStore';
import { isProduction, baseURL } from 'common/constants/common';
import styles from './Header.module.scss';

const searchClient = algoliasearch(
    'LFN8J4PA9S',
    'd016648758d5975d2f4d0972d91d557f',
);
// @ts-ignore
// eslint-disable-next-line
const isUserLoggedIn = window?.hydrateJSON?.isUserLoggedIn || window?.hydrateJSON?.loggedInUser || window?.hydrateJSONPremium?.loggedInUser || false;
// @ts-ignore
const TIGUrl = window?.hydrateJSON?.TIGUrl || window?.hydratePremium?.TIGUrl || 'https://www.theinstantgroup.com/en-gb/my-account/my-workspaces/';
// @ts-ignore
const isLocationAvailable = window?.hydrateJSON?.cityId || window?.hydrateJSON?.countryId || window?.hydrateJSON?.spaceId || (document.getElementById('post_requirements_city_id') as HTMLInputElement)?.value || (document.getElementById('post_requirements_country_id') as HTMLInputElement)?.value || false;
// @ts-ignore
const cityPhone = window?.hydrateJSON?.cityPhone || '';
// @ts-ignore
const phoneStyle = {
  color: '#00927c',
  fontFamily: 'Work Sans',
  fontSize: '17px',
  fontWeight: 700,
  lineHeight: '20px'
};
// @ts-ignore
const PhoneButton = () => {
  // Clean the phone number
  const cleanedPhone = cityPhone.replace(/[^+\d]/g, '');

  return (
      cityPhone && (
          <button className="phone">
            <a href={`tel:${cleanedPhone}`} style={phoneStyle}>
              {cityPhone} &nbsp;&nbsp;&nbsp;
            </a>
          </button>
      )
  );
};

// @ts-ignore
const PhoneButtonMobile = () => {
  // Clean the phone number
  const cleanedPhone = cityPhone.replace(/[^+\d]/g, '');

  return (
      cityPhone && (
          <div className={styles.phone}><a href={`tel:${cleanedPhone}`} style={phoneStyle}>
            <img src={PhoneIcon} className={styles.phone_icon}/>
          </a></div>
      )
  );
};

const Header: React.FC = observer(() => {
  const { locationName } = viewStore;
  const { isLaptop } = screenStore;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loginDropdownVisible, setLoginDropdownVisible] = useState(false);
  const [workspacesDropdownVisible, setWorkspacesDropdownVisible] = useState(false);
  const [locationsDropdownVisible, setLocationsDropdownVisible] = useState(false);
  const [mobileLocationsDropdownVisible, setMobileLocationsDropdownVisible] = useState(false);
  const [anyDropdownVisible, setAnyDropdownVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [displayedInputValue, setDisplayedInputValue] = useState('');

  React.useEffect(() => {
    const elementToRemove = document.getElementById('html_header');
    if (elementToRemove) {
      elementToRemove.remove();
    }
  },[])

  const closePopups = () => {
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.body.style.paddingRight = '0';
    setDisplayedInputValue(''); // maybe change this one
    setIsMenuOpen(false);
    setLoginDropdownVisible(false);
    setWorkspacesDropdownVisible(false);
    setLocationsDropdownVisible(false);
    setMobileLocationsDropdownVisible(false);
  };

  const toggleMenu = () => {
    closePopups();
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleDropdown = (
      setDropdownVisibility: React.Dispatch<React.SetStateAction<boolean>>,
      dropdownVisible: boolean,
  ) => {
    closePopups();
    document.body.style.overflow = anyDropdownVisible ? 'auto' : 'hidden';
    document.body.style.overflowX = 'hidden';
    document.body.style.paddingRight = anyDropdownVisible ? '0' : '15px';

    setDropdownVisibility(!dropdownVisible);
  };
  const toggleLoginDropdown = () => toggleDropdown(setLoginDropdownVisible, loginDropdownVisible);
  const toggleWorkspacesDropdown = () => toggleDropdown(setWorkspacesDropdownVisible, workspacesDropdownVisible);
  const toggleLocationsDropdown = () => toggleDropdown(setLocationsDropdownVisible, locationsDropdownVisible);
  const toggleMobileLocationsDropdown = () => setMobileLocationsDropdownVisible(!mobileLocationsDropdownVisible);

  const handleLoginClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    closePopups();
    document.querySelector('[class*="LoginPopupMain_background"]')?.setAttribute('style', 'display: block');
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = '15px';
  };

  // remove !
  const handleSignupClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const signupButton = (document.querySelector('[data-target="#signup-popup"][data-toggle="modal"]') || document.querySelector('a[onclick="openNavSignup();"]')) as HTMLElement;
    signupButton?.click();
  };

  useEffect(() => {
    setAnyDropdownVisible(loginDropdownVisible || workspacesDropdownVisible || locationsDropdownVisible);
  }, [
    loginDropdownVisible, workspacesDropdownVisible, locationsDropdownVisible,
  ]);

  // debounce for input field
  useEffect(() => {
    if (searchValue === '') {
      setDisplayedInputValue(searchValue);
    } else {
      const timer = setTimeout(() => {
        setDisplayedInputValue(searchValue);
      }, 500);

      return () => {
        clearTimeout(timer);
      };
    }

    return () => {};
  }, [searchValue]);

  // remove dropdown in case of window resize
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    if (isLaptop) {
      closePopups();
    }
  }, [windowWidth, isLaptop]);

  useEffect(() => {
    // remove empty results container
    const el = document.querySelectorAll('#header_results > ul > li');
    if (el.length === 0) {
      closePopups();
    }
  }, [displayedInputValue])

  return (
      <>
        <div
            className={classNames(styles.background, { [styles.active]: anyDropdownVisible || displayedInputValue })}
            onClick={closePopups}
        />
        <div className={styles.header_wrap} id="react_header_wrap" style={isLaptop ? { right: 0 } : { width: '100vw' }}>
          <header className={styles.header} id="react_header">
            <div className={styles.left}>
              <a href={baseURL}>
                <img alt="logo" className={styles.logo} src={logo} style={{width:"108px", height:"25px"}} />
              </a>
              <div className={styles.input_container} onClick={closePopups}>
                <div className={styles.input}>
                  <InstantSearch indexName={`${isProduction ? 'production' : 'staging'}_new_spaces`} searchClient={searchClient}>
                    <CustomSearchBox />
                    <StateResults setSearchValue={setSearchValue} />
                    {displayedInputValue && !anyDropdownVisible && (
                        <div className={styles.results_container} id="header_results">
                          <Index indexName={`${isProduction ? 'production' : 'staging'}_new_cities`}>
                            <CustomHits />
                          </Index>
                          <Index indexName={`${isProduction ? 'production' : 'staging'}_new_spaces`}>
                            <CustomHits />
                          </Index>
                          <Index indexName={`${isProduction ? 'production' : 'staging'}_new_countries`}>
                            <CustomHits />
                          </Index>
                        </div>
                    )}
                  </InstantSearch>
                </div>
                <div className={styles.search_icon}>
                  <img alt="search" src={search} style={{width:"32px", height:"30px"}} />
                </div>
              </div>
              <PhoneButtonMobile/>
            </div>

            <div className={styles.right}>
              <button className={styles.menu_button} onClick={toggleMenu} type="button">
                <img alt="menu" className={styles.menu} src={burger} />
              </button>

              <div className={classNames(styles.nav_container, { [styles.open]: isMenuOpen })}>
                {isMenuOpen && (
                    <a href={baseURL}>
                      <img alt="logo" className={styles.logo} src={logo} style={{width:"108px", height:"25px"}}/>
                    </a>
                )}
                <img alt="close" className={styles.close} onClick={toggleMenu} src={close} style={{height:"14px", width:"14px"}}/>
                <div className={styles.divider} />
                <nav className={styles.navigation}>
                  {/* remove false when ready to develop */}
                  {
                      locationName && false && (
                          <button
                              className={classNames({ [styles.active]: workspacesDropdownVisible })}
                              onClick={toggleWorkspacesDropdown}
                              type="button"
                          >
                            Workspaces
                          </button>
                      )
                  }
                  <PhoneButton />
                  <button
                      className={
                        classNames({ [styles.active]: locationsDropdownVisible || mobileLocationsDropdownVisible })
                      }
                      id={styles.location_dropdown}
                      onClick={isLaptop ? toggleMobileLocationsDropdown : toggleLocationsDropdown}
                      type="button"
                  >
                    Locations
                    {isLaptop && <Chevron style={{ transform: mobileLocationsDropdownVisible ? 'rotate(180deg)' : 'none' }} />}
                  </button>
                  {/* duplicate for mobile dropdown quick */}
                  {mobileLocationsDropdownVisible && (
                      <div className={styles.locations_dropdown_mobile}>
                        {cities.map((column, i) => (
                            <div key={`column-${column[i]}`} className={styles.column}>
                              {column.map((city) => (
                                  <a key={city.url} className={styles.city} href={baseURL + city.url}>
                                    {city.name}
                                  </a>
                              ))}
                            </div>
                        ))}
                      </div>
                  )}
                  <a href={`${baseURL}about-us`}>About us</a>
                  <a href={`${baseURL}list-space`}>List space</a>
                  {/* @ts-ignore */}
                  {/* eslint-disable-next-line */}
                  {isLocationAvailable && <a
                      className={styles.contact}
                      data-name="booking-enquiry-submit"
                      onClick={(e) => {
                        e.preventDefault();
                        const target = e.target as HTMLElement;

                        const globalAny: any = global;

                        // Tracking data source (fallbacks)
                        const spaceId =
                            document.getElementById('space_id')?.getAttribute('value') ?? '0';
                        const ratingScore =
                            document.getElementById('ratingScore_id')?.getAttribute('value') ?? '0';

                        const listingsCardPosition = sessionStorage.getItem('listingsCardPosition') ?? null;
                        const listingsPageNumber = sessionStorage.getItem('listingsPageNumber') ?? null;
                        const isPopular = false; // You may dynamically determine this

                        // Set global tracking data if needed elsewhere
                        globalAny.quickQuoteTrackingData = {
                          cs_id: spaceId,
                          ratingScore,
                          isPopular,
                          listingsCardPosition,
                          listingsPageNumber,
                        };

                        // Push to dataLayer
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: 'enquire_now_open',
                          centre_id: spaceId,
                          popular: isPopular,
                          rating_score: ratingScore,
                          listings_card_position: listingsCardPosition,
                          listings_page_number: listingsPageNumber,
                        });

                        // Open modal
                        openModal(FormType.GeneralEnquiry, target);
                      }}
                  >
                    Contact
                  </a>
                  }

                  <div className={styles.mobile_nav_container}>
                    {isUserLoggedIn ? (
                        <>
                          <a className={styles.mobile_nav} href={`${baseURL}profile/my-space`}>My Coworking Space</a>
                          <a className={styles.mobile_nav} href={`${baseURL}profile/myreviews`}>Your Reviews</a>
                          <a className={styles.mobile_nav} href={`${baseURL}profile`}>Edit Profile</a>
                          <a className={styles.mobile_nav} href={`${baseURL}profile/editprofile`}>Account Settings</a>
                          <a className={styles.mobile_nav} href={`${baseURL}logout`}>Log Out</a>
                        </>
                    ) : (
                        <>
                          <button className={styles.mobile_nav} onClick={handleLoginClick} type="button">Log In</button>
                          <button className={styles.mobile_nav} onClick={handleSignupClick} type="button">Sign Up</button>
                        </>
                    )}

                    <a className={styles.mobile_nav} href={TIGUrl} target="_blank">
                      My Account
                      <img alt="link" className={styles.link} src={link} style={{height:"10px"}}/>
                    </a>
                  </div>
                </nav>

                <img alt="avatar" className={classNames(styles.avatar, { [styles.active]: loginDropdownVisible })} onClick={toggleLoginDropdown} src={avatar} style={{height:"24px",width:"24px"}}/>

                {loginDropdownVisible && (
                    <div className={styles.login_dropdown}>
                      {isUserLoggedIn ? (
                          <>
                            <a href={`${baseURL}profile/my-space`}>My Coworking Space</a>
                            <a href={`${baseURL}profile/myreviews`}>Your Reviews</a>
                            <a href={`${baseURL}profile`}>Edit Profile</a>
                            <a href={`${baseURL}profile/editprofile`}>Account Settings</a>
                            <a href={`${baseURL}logout`}>Log Out</a>
                          </>
                      ) : (
                          <>
                            <button onClick={handleLoginClick} type="button">Log In</button>
                            <button onClick={handleSignupClick} type="button">Sign Up</button>
                          </>
                      )}
                      <a href={TIGUrl} target="_blank">
                        My Account
                        <img alt="link" className={styles.link} src={link} />
                      </a>
                    </div>
                )}
              </div>

              {workspacesDropdownVisible && (
                  <div className={styles.workspaces_dropdown}>
                    {workspaceTypes.map((workspace) => (
                        <a
                            key={workspace.href}
                            className={styles.workspace_container}
                            href={`${baseURL}search/${locationName}&resource_types=${workspace.href}`}
                        >
                          <img alt={workspace.alt} src={workspace.img} />
                          <div className={styles.workspace_info}>
                            <p className={styles.workspace_heading}>{workspace.heading}</p>
                            <span className={styles.workspace_description}>{workspace.description}</span>
                          </div>
                        </a>
                    ))}
                  </div>
              )}

              {locationsDropdownVisible && (
                  <div className={styles.locations_dropdown}>
                    {cities.map((column, i) => (
                        <div key={`column-${column[i]}`} className={styles.column}>
                          {column.map((city) => (
                              <a key={city.url} className={styles.city} href={baseURL + city.url}>
                                {city.name}
                              </a>
                          ))}
                        </div>
                    ))}
                  </div>
              )}
            </div>
          </header>
        </div>
      </>
  );
});

export default Header;
